import { render, staticRenderFns } from "./SfSearchBar.vue?vue&type=template&id=c8c00d2c&"
import script from "./SfSearchBar.vue?vue&type=script&lang=js&"
export * from "./SfSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SfSearchBar.vue?vue&type=style&index=0&id=c8c00d2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports